// import React from "react";
// import Navbar from "./Navbar";
// import Footer from "./Footer";
// import banner1 from "../assets/images/policy.jpg";
// import Whatsapp from "../components/Whatsapp";
// import "../assets/css/style.css";

// const PrivacyPolicy = () => {
//   return (
//     <div>
//       <Navbar />
//       <div className="project-banner" style={{ backgroundImage: `url(${banner1})` }}>
//       </div>

//       {/* <div className="privacy-policy-container w-full sm:max-w-4xl mx-auto p-4 sm:p-8 shadow-lg rounded-lg  mt-12 sm:mt-16 sm:pt-16 "> */}
//       <div className="privacy-policy-container w-full max-w-screen-lg mx-auto px-6 sm:px-12 py-8 sm:py-16 shadow-lg rounded-lg mt-12 sm:mt-16">
//         <h2 className="text-2xl sm:text-4xl font-bold mb-4 sm:mb-6 text-gray-800 text-left">Privacy Policy</h2>
//         <p className="text-base sm:text-xl text-gray-700 leading-relaxed fs-5">
//           At Murali Krishna Estate, we are dedicated to safeguarding your personal information. This policy outlines how we gather, utilize, and secure your data.
//         </p>

//         <h3 className="text-xl sm:text-3xl font-semibold mt-4 sm:mt-6 text-gray-800">Information We Collect</h3>
//         <ul className="list-circle pl-4 sm:pl-6 mt-2 text-base sm:text-xl text-gray-700 leading-relaxed fs-5">
//           <li><strong>Personal Data:</strong> Name, contact details, and mailing address.</li>
//           <li><strong>Technical Data:</strong> Browser type, device details, and IP address.</li>
//           <li><strong>Transaction Data:</strong> Property inquiries and service requests.</li>
//         </ul>

//         <h3 className="text-xl sm:text-3xl font-semibold mt-4 sm:mt-6 text-gray-800">How We Use Your Information</h3>
//         <p className="text-base sm:text-xl text-gray-700 fs-5">We process your data for purposes such as:</p>
//         <ul className="list-circle pl-4 sm:pl-6 mt-2 text-base sm:text-xl text-gray-700 leading-relaxed fs-5">
//           <li>1. Facilitating property transactions and real estate services.</li>
//           <li>2. Responding to inquiries and sending relevant updates.</li>
//           <li>3. Improving website functionality and user experience.</li>
//           <li>4. Meeting legal and regulatory obligations.</li>
//         </ul>

//         <h3 className="text-xl sm:text-3xl font-semibold mt-4 sm:mt-6 text-gray-800">Sharing Your Information</h3>
//         <p className="text-base sm:text-xl text-gray-700 fs-5">We may share your information with:</p>
//         <ul className="list-circle pl-4 sm:pl-6 mt-2 text-base sm:text-xl text-gray-700 leading-relaxed fs-5">
//           <li>1. Trusted service providers for payments and IT support.</li>
//           <li>2. Legal authorities if required for compliance or security reasons.</li>
//           <li>3. Authorized agents for transaction-related activities.</li>
//         </ul>
//         <p className="mt-2 text-base sm:text-xl text-gray-700"><strong>Note:</strong> We do not sell your personal information.</p>

//         <h3 className="text-xl sm:text-3xl font-semibold mt-4 sm:mt-6 text-gray-800">Data Security</h3>
//         <p className="text-base sm:text-xl text-gray-700 leading-relaxed fs-5">
//           We employ security measures to prevent unauthorized access to your data. However, no system is completely secure, and we encourage users to take necessary precautions.
//         </p>

//         <h3 className="text-xl sm:text-3xl font-semibold mt-4 sm:mt-6 text-gray-800">Your Rights</h3>
//         <p className="text-base sm:text-xl text-gray-700 fs-5">Depending on your location, you may have rights to:</p>
//         <ul className="list-circle pl-4 sm:pl-6 mt-2 text-base sm:text-xl text-gray-700 leading-relaxed fs-5">
//           <li>1. Access, update, or delete your personal data.</li>
//           <li>2. Opt-out of marketing communications.</li>
//           <li>3. Restrict or object to specific data processing.</li>
//         </ul>
//         <p className="mt-2 text-base sm:text-xl text-gray-700">For assistance, contact us at <strong>8333939888, 9666047773</strong>.</p>

//         <h3 className="text-xl sm:text-3xl font-semibold mt-4 sm:mt-6 text-gray-800">Cookies & Tracking</h3>
//         <p className="text-base sm:text-xl text-gray-700 leading-relaxed fs-5">
//           Our website uses cookies to enhance your browsing experience. You can manage cookie settings via your browser preferences.
//         </p>
//         <h3 className="text-xl sm:text-3xl font-semibold mt-4 sm:mt-6 text-gray-800">External Links</h3>
//         <p className="text-base sm:text-xl text-gray-700 leading-relaxed fs-5">
//           We may provide links to third-party websites. We do not control their content or privacy policies, so please review them before sharing information.
//         </p>

//         <h3 className="text-xl sm:text-3xl font-semibold mt-8 sm:mt-12 text-gray-800">Policy Updates</h3>
//         <p className="text-base sm:text-xl text-gray-700 leading-relaxed fs-5">
//           We may update this Privacy Policy from time to time. Changes take effect immediately upon posting. Please check this page periodically.
//         </p>
//       </div>
//     <Whatsapp />
//   <Footer />
// </div>
//   );
// };

// export default PrivacyPolicy;





























import React from "react";
import Navbar from "./Navbar";
import Footer from "./Footer";
import banner1 from "../assets/images/policy.jpg";
import Whatsapp from "../components/Whatsapp";
import "../assets/css/style.css";

const PrivacyPolicy = () => {
  return (
    <div>
      <Navbar />

      <div className="project-banner" style={{ backgroundImage: `url(${banner1})` }} />

      <div className="privacy-policy-container">
        <h2 className="title">Privacy Policy</h2>
        <p className="paragraph">
        At Devi Vinayaka Builders, we respect your privacy and are committed to protecting your personal information. 
        This Privacy Policy explains how we collect, use, disclose, and safeguard your data when you interact with us 
        whether through our website, in person, or via other communication channels.
        </p>


        <h3 className="subtitle">Information We Collect</h3>
<p className="paragraph">
  To provide you with the best real estate services, we may collect the following types of data:
</p>

<ol className="list list-decimal pl-4">
  <li className="mb-2">
    <strong>Personal Information:</strong> <br />
    1. Name, email address, phone number, and residential or mailing address. <br />
    2. Identification documents for verification, if necessary.
  </li>
  <li className="mb-2">
    <strong>Technical Information:</strong> <br />
    Device details, browser type, IP address, and website usage behavior.
  </li>
  <li className="mb-2">
    <strong>Transactional Information:</strong> <br />
    Property inquiry details, purchase history, and service interactions.
  </li>
</ol>


        <h3 className="subtitle">How We Use Your Information</h3>
        <p className="paragraph">Your information helps us to:</p>
        <ul className="list">
          <li>1. Assist with property buying, selling, and rental services</li>
          <li>2. Respond promptly to your inquiries and follow-ups</li>
          <li>3. Provide updates on project launches, offers, or related communications</li>
          <li>4. Enhance user experience and improve our digital platforms</li>
          <li>5. Fulfill legal, regulatory, and compliance obligations</li>
        </ul>

        <h3 className="subtitle">Sharing Your Information</h3>
        <p className="paragraph">We may share your information only with trusted entities, including:</p>
        <ul className="list">
          <li>1. Third-party service providers such as IT, payment, and marketing partners</li>
          <li>2. Legal or regulatory authorities when required by law</li>
          <li>3. Channel partners or agents assisting in property transactions</li>
        </ul>
        <p className="note"><strong>Note:</strong>We do not sell or rent your personal information to any third party.</p>

        <h3 className="subtitle">Data Security</h3>
        <p className="paragraph">
        We implement industry-standard measures to protect your data against unauthorized access or misuse. While we 
        strive to ensure complete security, we also encourage users to adopt safe browsing practices.
        </p>

        <h3 className="subtitle">Your Privacy Rights</h3>
        <p className="paragraph">Depending on applicable data protection laws, you may have the right to:</p>
        <ul className="list">
          <li>1. Request access to the personal information we hold about you</li>
          <li>2. Correct or update inaccurate or incomplete data</li>
          <li>3. Withdraw consent or opt-out of marketing communications</li>
          <li>4. Request deletion or restriction of your data in certain cases</li>
        </ul>
        <p className="paragraph">
        For assistance or to exercise your rights, please contact us at:<strong>8977060666, 6305252452</strong>.
        </p>

        <h3 className="subtitle">Cookies & Tracking</h3>
        <p className="paragraph">
        Our website uses cookies and analytics tools to provide a more personalized browsing experience. 
        You can modify cookie preferences through your browser settings.
        </p>

        <h3 className="subtitle">Third-Party Links</h3>
        <p className="paragraph">
        We may offer links to third-party websites for your convenience. Devi Vinayaka Builders is not responsible for the 
        content, privacy practices, or accuracy of these external sites. Please review their privacy policies before 
        engaging with them.
        </p>

        <h3 className="subtitle">Policy Updates</h3>
        <p className="paragraph">
        This Privacy Policy may be updated periodically to reflect changes in our services or legal requirements. 
        Updated policies will be published on this page with immediate effect. We recommend checking this page from time 
        to time.
        </p>
      </div>

      <Whatsapp />
      <Footer />
    </div>
  );
};

export default PrivacyPolicy;




